import { createSelector } from '@reduxjs/toolkit';

export const selectAuthUser = (state: ReturnType<any>) => state.authUser;

export const authSelector = createSelector(
    selectAuthUser,
    (state) => state,
);
